// all saved only to the current computer
import { LocalUiHelperSettings } from './ui-helper.model';

export const UI_LOCAL_HELPER_DEFAULT: LocalUiHelperSettings = {
  zoomFactor: 1,
};
